import { render, staticRenderFns } from "./table-column.vue?vue&type=template&id=cbc02876&"
import script from "./table-column.vue?vue&type=script&lang=js&"
export * from "./table-column.vue?vue&type=script&lang=js&"
import style0 from "./table-column.vue?vue&type=style&index=0&id=cbc02876&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbc02876')) {
      api.createRecord('cbc02876', component.options)
    } else {
      api.reload('cbc02876', component.options)
    }
    module.hot.accept("./table-column.vue?vue&type=template&id=cbc02876&", function () {
      api.rerender('cbc02876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table-column.vue"
export default component.exports